/**
 * Copyright IBM Corp. 2016, 2018
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import PropTypes from 'prop-types';
export var ListBoxType = PropTypes.oneOf(['default', 'inline']);
export var ListBoxSize = PropTypes.oneOf(['sm', 'xl']);